import React from "react";
import { connect } from "react-redux";

//import { withStyles } from "@material-ui/core/styles";
import useStyles from "./styles";
import { Button, CircularProgress } from "@material-ui/core";
import { PauseCircleFilled as PauseCircleFilledIcon, PlayCircleOutline as PlayCircleOutlineIcon } from "@material-ui/icons";

//store
import * as actions from "../../store/actions/actionIndex";
import { useLoader } from "../../context/LoaderContext";
import Loading from "../Loading";

function HoldButton(props) {
	var classes = useStyles();
	const componentId = 'HoldButton';
	const { loading, showLoader} = useLoader(componentId);

	const handleClick = () => {
		showLoader();
		props.onAgentHold(props.agentId, props.isHold === "MUNHOLD" ? "HOLD" : "UNHOLD");
	};

	return (
		<div>
		{loading ? <Loading/> : 
			<Button variant="contained" size="small" className={classes.HoldandResumeButton} style={{ marginLeft: "10px", height: "36px", color: "tomato", backgroundColor: "aliceblue", border: "2px solid", textTransform: "capitalize" }} onClick={handleClick}>
				{props.loading ? <CircularProgress size={18} style={{ verticalAlign: "middle" }} /> : props.isHold === "MUNHOLD" ? <PauseCircleFilledIcon style={{ color: "tomato" }} /> : <PlayCircleOutlineIcon />}
				&nbsp;{props.isHold === "MUNHOLD" ? " Hold Call" : " Resume"}
			</Button>
		}
		{/* <Button variant="contained" size="small" className={classes.HoldandResumeButton} style={{ marginLeft: "10px", height: "36px", color: "tomato", backgroundColor: "aliceblue", border: "2px solid", textTransform: "capitalize" }} onClick={handleClick}>
				{props.loading ? <CircularProgress size={18} style={{ verticalAlign: "middle" }} /> : props.isHold === "MUNHOLD" ? <PauseCircleFilledIcon style={{ color: "tomato" }} /> : <PlayCircleOutlineIcon />}
				&nbsp;{props.isHold === "MUNHOLD" ? " Hold Call" : " Resume"}
			</Button> */}
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		error: state.agentHold.error,
		loading: state.agentHold.loading,
		isHold: state.agentData.isHold,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onAgentHold: (agentId, holdState) => dispatch(actions.agentHold(agentId, holdState)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HoldButton);
